/**
 * Сервис для работы с разделом администратора
 */

import axios from 'axios';
import { IId, IFallSettings, IAccStillSettings } from '../models/types';

const url = '/admin';

const AdminService = {
  getCompanyConfig: () => axios.get(`/v0/config/company`),
  getTimeTableConfig: () => axios.get(`/v0/config/timetable`),
  getSecurableTypes: (id: IId) => axios.get(`${url}/securableTypes?uid=${id}`),
  getConfig: (configType: string) => axios.get(`/v0/config/${configType}`),
  saveConfig: (configType: string, data: any) =>
    axios.post(`/v0/config/${configType}`, data, {
      headers: { 'Content-Type': 'application/json' },
      transformRequest: [(data: any) => data] // Отправляем данные как есть, без сериализации
    }),
  getFallSettings: () => axios.get(`/v0${url}/fall`),
  saveFallSettings: (data: IFallSettings) => axios.put(`/v0${url}/fall`, data),
  getAccStillSettings: () => axios.get(`/v0${url}/acc-still`),
  saveAccStillSettings: (data: IAccStillSettings) => axios.put(`/v0${url}/acc-still`, data)
};

export default AdminService;
